import { EntityService } from '../../core/services/entity.service';
import { GlobalService } from '../../core/services/global.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Response } from '@angular/http';
import { SelectList } from '../model/selectList';

@Injectable()
export class LocationService {

    constructor(private http: GlobalService, private entityService: EntityService) {
    }

    getCountries(): Observable<SelectList[]> {
        const url = `locations/countries`;
        return this.http.get(url)
            .map(res => this.entityService.extractData<SelectList[]>(res))
            .map(data => (data && data.map) ? data.map(x => this.entityService.copy(x, new SelectList())) : []);
    }

    getStatesByCountry(countryId: number): Observable<SelectList[]> {
        const url = `locations/states/${countryId}`;
        return this.http.get(url)
            .map(res => this.entityService.extractData<SelectList[]>(res))
            .map(data => (data && data.map) ? data.map(x => this.entityService.copy(x, new SelectList())) : []);
    }
}



// WEBPACK FOOTER //
// C:/Users/Pablo/source/repos/prote/angular/src/app/shared-model/services/location.service.ts